import { Tabs, Tab, Paper } from "@mui/material";
import { PROFILE_NAV_ITEMS } from "./profileNavConfig";

export function ProfileTopTabNav({
  value,
  onChange,
}: {
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <Paper elevation={1} square>
      <Tabs
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
      >
        {PROFILE_NAV_ITEMS.map((item) => (
          <Tab
            key={item.id}
            value={item.id}
            label={item.label}
            icon={item.icon}
            iconPosition="start"
          />
        ))}
      </Tabs>
    </Paper>
  );
}
